import React from 'react'
import PropTypes from 'prop-types'
import styles from './Header.module.scss'
import classnames from 'classnames'

const Header = (props) => {
  const  {
    children,
    className,
    hide
  } = props

  const classes = classnames(styles.Header, className)
  return  (
    <div className={classes}>
      {!hide &&
      <div className={styles.headerWrapper} data-test-id="header">
        {typeof children === 'string' ?
          <div className={styles.text}>{children}</div> :
          children
        }
      </div>
      }
    </div>
  )
}

Header.defaultProps = {
  className: null,
  hide: false
}

Header.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  hide: PropTypes.bool
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Client/Header/Header.js